import { Component, inject, Input, OnChanges, SimpleChanges, TemplateRef } from '@angular/core';

import { CommonModule, NgOptimizedImage } from '@angular/common';
import { delay, map, of, tap } from 'rxjs';
import { Bildungsangebot } from '../../../model';
import { PaginationService } from '../../../services/suchseite/pagination.service';

@Component({
  selector: 'now-wbsuche-lib-angebot-termine-slider',
  templateUrl: './angebot-termine-slider.component.html',
  styleUrls: ['./angebot-termine-slider.component.scss'],
  imports: [CommonModule, NgOptimizedImage]
})
export class AngebotTermineSliderComponent implements OnChanges {
  @Input()
  angebotTemplate!: TemplateRef<any>;
  @Input()
  selectedAngebot!: Bildungsangebot;

  private readonly paginationService = inject(PaginationService);

  public pageInfos$ = this.paginationService.pageInfos$;

  // Helfer Objekte um die Slide in Animation zu implementieren
  public prevAngebot?: Bildungsangebot | null;
  // Ist true solange das Angebot gewechselt wird (Entspricht der Animationsdauer)
  public angebotChanging = false;

  public anzahlAngebotePlural = { '=1': ' Angebot', other: ' Angebote' };

  ngOnChanges(changes: SimpleChanges): void {
    this.initAnimationHelpers(changes);
  }

  // Immer wenn ein neues Angebot ausgewählt wurde,
  // wird ein Placeholder Element gerendert in dem das
  // vorherige Angebot (prevAngebot) langsam ausgeblendet wird
  // und das neue Angebot von links hinein slidet.
  // Anschließend wird der Placeholder wieder ausgeblendet
  // und nur noch das neue Agebot ist sichtbar.
  private initAnimationHelpers(changes: SimpleChanges): void {
    if (changes.selectedAngebot?.firstChange) {
      this.prevAngebot = changes.selectedAngebot?.currentValue;
    } else if (
      changes.selectedAngebot?.currentValue &&
      changes.selectedAngebot?.currentValue != changes.selectedAngebot?.previousValue
    ) {
      this.angebotChanging = true;
      of(null)
        .pipe(
          // Dauer der Animation, bzw minimal länger um Flackern in der UI zu verhindern.
          delay(300),
          tap(() => {
            this.angebotChanging = false;
            this.prevAngebot = changes.selectedAngebot?.currentValue;
          })
        )
        .subscribe();
    } else {
      this.prevAngebot = null;
    }
  }
}
